<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<mat-form-field [title]="title" appearance="outline" class="lf-field">
  <mat-select panelClass="lf-dropdown-overlay" [formControl]="formControl" [title]="formControl.value"
    (selectionChange)="onValueChanged()" [compareWith]="compareWith" >
    <mat-option>--</mat-option>
    <mat-option *ngFor="let listOption of options" [value]="listOption">
      {{listOption}}
    </mat-option>
  </mat-select>
  <mat-error *ngIf="getBrokenValidationRule()">{{fieldValidationErrorMsg | async}}</mat-error>
</mat-form-field>
